import { mq, spacing, styled, Text } from '@thg-commerce/gravity-theme'
import { GridItem } from '@thg-commerce/gravity-system'
import { Button } from '@thg-commerce/gravity-elements'

export const Container = styled.div<{
  isPermanentlyClosed?: boolean
}>`
  display: flex;
  flex-direction: column;
  margin-top: ${(props) =>
    props.isPermanentlyClosed ? spacing(2) : spacing(3)};
  margin-bottom: ${spacing(6)};
  padding: 0 ${spacing(2)};
  ${(props) => props.isPermanentlyClosed && 'align-items: center;'}
  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    margin-bottom: ${spacing(10)};
  }
  ${(props) => mq(props.theme.breakpointUtils.map, 'md')} {
    margin-top: ${(props) =>
      props.isPermanentlyClosed ? spacing(2) : spacing(6)};
    ${(props) => !props.isPermanentlyClosed && 'flex-direction: row;'};
  }
`

export const StoreInfoContainer = styled.div`
  flex: 1;
  order: 2;
  margin-right: 0;
  margin-bottom: ${spacing(3)};
  padding-bottom: ${spacing(3)};
  border-bottom: 1px solid ${(props) => props.theme.colors.palette.greys.light};

  ${(props) => mq(props.theme.breakpointUtils.map, 'md')} {
    order: 1;
    margin-right: ${spacing(2)};
    margin-bottom: 0;
    padding-bottom: 0;
    border-bottom: none;
  }
`

export const OpeningTimesContainer = styled.div`
  flex: 1;
  order: 1;
  margin-right: 0;
  margin-bottom: ${spacing(3)};
  padding-bottom: ${spacing(3)};
  border-bottom: 1px solid ${(props) => props.theme.colors.palette.greys.light};

  ${(props) => mq(props.theme.breakpointUtils.map, 'md')} {
    order: 2;
    margin-bottom: 0;
    padding-bottom: 0;
    border-bottom: none;
    &:not(:last-child) {
      margin-right: ${spacing(2)};
    }
  }
`
export const StyledMapWrapper = styled.div`
  height: 228px;
  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    height: 416px;
  }
`

export const FacilitiesContainer = styled.div`
  flex: 1;
  order: 3;
  border-bottom: 1px solid ${(props) => props.theme.colors.palette.greys.light};
  padding-bottom: ${spacing(3)};

  ${(props) => mq(props.theme.breakpointUtils.map, 'md')} {
    order: 3;
    border-bottom: none;
    padding-bottom: 0;
  }
`

export const SectionTitle = styled.p`
  ${Text('medium1', 'alternate')};
  margin-bottom: ${spacing(2)};
`

export const AddressContainer = styled.div<{ isPermanentlyClosed?: boolean }>`
  margin-bottom: ${(props) =>
    props.isPermanentlyClosed ? spacing(2) : spacing(1.5)};
  ${(props) => props.isPermanentlyClosed && 'text-align: center;'}
`

export const AddressText = styled.p`
  ${Text('medium1', 'default')};
  margin: 0;
`

export const ContactText = styled.a<{ isPermanentlyClosed?: boolean }>`
  ${Text('bodyText', 'default')}
  display: flex;
  margin-top: ${(props) => (props.isPermanentlyClosed ? '0' : spacing(2))};
`

export const OpeningTimesDayText = styled(GridItem)<{
  isTodaysOpeningTimeObject?: boolean
}>`
  ${(props) =>
    Text('bodyText', props.isTodaysOpeningTimeObject ? 'alternate' : 'default')}
  text-transform: capitalize;
`

export const OpeningTimesText = styled(GridItem)<{
  isTodaysOpeningTimeObject?: boolean
}>`
  ${(props) =>
    Text('bodyText', props.isTodaysOpeningTimeObject ? 'alternate' : 'default')}
  width: max-content;
`

export const OpeningTimesStatusText = styled(GridItem)<{
  isTodaysOpeningTimeObject?: boolean
}>`
  ${(props) =>
    Text('bodyText', props.isTodaysOpeningTimeObject ? 'alternate' : 'default')}
`

export const ContactButton = styled(Button)`
  &&,
  &:hover,
  &:active,
  &:focus,
  &:disabled {
    ${Text('bodyText', 'default')}
    text-decoration: none;
  }
`
